import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import findReactFiber from './find-react-fiber';
import getComponentName from './get-component-name';
var DEFAULT_MAX_LEVEL = 20;
// Using the React Fiber tree to traverse up the DOM and check if a node is within a specific component
// and extract child component props if needed.
export default function checkWithinComponentAndExtractChildProps(node, targetComponentName, childComponentConfig) {
  var fiber = null;
  if (fg('platform_ufo_handle_non_react_element_for_3p')) {
    // Walk up the DOM tree to find React fiber (handles non-React-rendered elements)
    var currentElement = node;
    var levelsTraversed = 0;
    while (currentElement && !fiber && levelsTraversed < DEFAULT_MAX_LEVEL) {
      fiber = findReactFiber(currentElement);
      if (!fiber) {
        currentElement = currentElement.parentElement;
      }
      levelsTraversed++;
    }
  } else {
    fiber = findReactFiber(node);
  }

  // If no React fiber found, return false
  if (!fiber) {
    return {
      isWithin: false
    };
  }

  // Traverse up the fiber tree
  var currentFiber = fiber;
  var childProp;
  while (currentFiber) {
    var componentName = getComponentName(currentFiber);

    // Check if this is a child component we're looking for
    if (childComponentConfig && componentName === childComponentConfig.componentName) {
      var props = currentFiber.memoizedProps || currentFiber.pendingProps;
      if (props && props[childComponentConfig.propName] !== undefined) {
        // Overwrite with the nearest child prop (closest to the target component)
        childProp = childComponentConfig.extractValue ? childComponentConfig.extractValue(props) : props[childComponentConfig.propName];
      }
    }

    // Check if we found the target component
    if (componentName === targetComponentName) {
      return _objectSpread({
        isWithin: true
      }, childComponentConfig && {
        childProp: childProp
      });
    }
    currentFiber = currentFiber.return;
  }
  return {
    isWithin: false
  };
}